import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "Common/withRouter";
import { Collapse } from "react-bootstrap";

import { withTranslation } from "react-i18next";

// Import Data
import navdata from "../LayoutMenuData";
import { Link } from "react-router-dom";
import { clearAllTableStates } from "utils/clearTableStates";

const VerticalLayout = (props: any) => {
  const path = props.router.location.pathname;
  const navData = navdata().props.children;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + path;
      const ul: any = document.getElementById("navbar-nav");
      
      // Check if the element exists before proceeding
      if (!ul) {
        return;
      }
      
      const items = ul.getElementsByTagName("a");
      let itemsArray = Array.from<HTMLAnchorElement>(items); // converts NodeList to Array
      removeActivation(itemsArray);
      // let matchingMenuItem = itemsArray.find((x) => {
      //     return x.pathname === pathName;
      // });
      const matchPath = (pattern: string, actualPath: string) => {
        // Convert '/edit-package/:id' to regex like /^\/edit-package\/[^/]+$/
        const regex = new RegExp(
          "^" + pattern.replace(/:[^/]+/g, "[^/]+") + "$"
        );
        return regex.test(actualPath);
      };

      const matchingMenuItem = itemsArray.find((x) => {
        const activeurl = (x.getAttribute("data-set") || "").split(",");
        return (
          x.pathname === pathName ||
          activeurl.some((pattern: string) =>
            matchPath(pattern.trim(), pathName)
          )
        );
      });

      // console.log("matchingMenuItem", matchingMenuItem);

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      } else {
        // Fallback: if no menu item is found, try again after a longer delay
        // This handles the case where menu items are still loading
        setTimeout(() => {
          const retryUl = document.getElementById("navbar-nav");
          if (!retryUl) {
            return;
          }
          const retryItems = retryUl.getElementsByTagName("a");
          const retryItemsArray = Array.from<HTMLAnchorElement>(retryItems);
          const retryMatchingMenuItem = retryItemsArray.find((x) => {
            const activeurl = (x.getAttribute("data-set") || "").split(",");
            return (
              x.pathname === pathName ||
              activeurl.some((pattern: string) =>
                matchPath(pattern.trim(), pathName)
              )
            );
          });
          if (retryMatchingMenuItem) {
            activateParentDropdown(retryMatchingMenuItem);
          }
        }, 500);
      }
    };
    if (props.layoutType === "vertical") {
      // Add a small delay to ensure menu items are rendered
      setTimeout(() => {
        initMenu();
      }, 500);
    }
  }, [path, props.layoutType]);

  function activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute(
        "aria-expanded",
        "true"
      );
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement
          .closest(".collapse")
          .classList.add("show");
        if (
          parentCollapseDiv.parentElement.closest(".collapse")
            .previousElementSibling
        )
          parentCollapseDiv.parentElement
            .closest(".collapse")
            .previousElementSibling.classList.add("active");
      }
      return false;
    }
    return false;
  }

  const removeActivation = (items: any) => {
    let actiItems = items.filter((x: any) => x.classList.contains("active"));

    actiItems.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  };

  // console.log("Navdata here... ", navData)

  return (
    <React.Fragment>
      {/* menu Items */}
      {(navData || []).map((item: any, key: number) => {
        return (
          <React.Fragment key={key}>
            {/* Main Header */}
            {item["isHeader"] ? (
              <li className="menu-title">
                <span data-key="t-menu">{props.t(item.label)} </span>
              </li>
            ) : item.subItems ? (
              <li className="nav-item">
                <Link
                  to={item.link ? item.link : "/"}
                  onClick={item.click}
                  className="nav-link menu-link"
                  data-bs-toggle="collapse"
                >
                  <i className={item.icon}></i>
                  <span data-key="t-apps">{props.t(item.label)}</span>
                  {item.badgeName ? (
                    <span
                      className={"badge badge-pill bg-soft-" + item.badgeColor}
                      data-key="t-new"
                    >
                      {item.badgeName}
                    </span>
                  ) : null}
                </Link>
                <Collapse
                  className="menu-dropdown"
                  // className="menu-dropdown"
                  in={item.stateVariables}
                >
                  <div id="example-collapse-text">
                    <ul className="nav nav-sm flex-column">
                      {/* subItms  */}
                      {item.subItems &&
                        (item.subItems || []).map(
                          (subItem: any, key: number) => (
                            <React.Fragment key={key}>
                              {!subItem.isChildItem ? (
                                <li className="nav-item">
                                  <Link
                                    to={subItem.link ? subItem.link : "/"}
                                    className="nav-link"
                                    data-set={subItem?.activeUrl}
                                    onClick={() => {
                                      // Clear all table states when clicking sidebar navigation links
                                      if (
                                        subItem.link &&
                                        subItem.link !== "/#"
                                      ) {
                                        clearAllTableStates();
                                      }
                                    }}
                                  >
                                    {subItem.icon && (
                                      <i className={subItem.icon}></i>
                                    )}{" "}
                                    {props.t(subItem.label)}
                                    {subItem.badgeName ? (
                                      <span
                                        className={
                                          "badge badge-pill bg-soft-" +
                                          subItem.badgeColor
                                        }
                                        data-key="t-new"
                                      >
                                        {subItem.badgeName}
                                      </span>
                                    ) : null}
                                  </Link>
                                </li>
                              ) : (
                                <li className="nav-item">
                                  <Link
                                    to={process.env.PUBLIC_URL + "/"}
                                    onClick={subItem.click}
                                    className="nav-link"
                                    data-bs-toggle="collapse"
                                  >
                                    {subItem.icon && (
                                      <i className={subItem.icon}></i>
                                    )}{" "}
                                    {props.t(subItem.label)}
                                  </Link>
                                  <Collapse
                                    className="menu-dropdown"
                                    in={subItem.stateVariables}
                                  >
                                    <div>
                                      <ul className="nav nav-sm flex-column">
                                        {/* child subItms  */}
                                        {subItem.subItems &&
                                          (subItem.subItems || []).map(
                                            (childItem: any, key: number) => (
                                              <React.Fragment key={key}>
                                                {!childItem.subItems ? (
                                                  <li className="nav-item">
                                                    <Link
                                                      to={
                                                        childItem.link
                                                          ? childItem.link
                                                          : "/"
                                                      }
                                                      className="nav-link"
                                                      onClick={() => {
                                                        // Clear all table states when clicking sidebar navigation links
                                                        if (
                                                          childItem.link &&
                                                          childItem.link !==
                                                            "/#"
                                                        ) {
                                                          clearAllTableStates();
                                                        }
                                                      }}
                                                    >
                                                      {childItem.icon && (
                                                        <i
                                                          className={
                                                            childItem.icon
                                                          }
                                                        ></i>
                                                      )}{" "}
                                                      {props.t(childItem.label)}
                                                    </Link>
                                                  </li>
                                                ) : (
                                                  <li className="nav-item">
                                                    <Link
                                                      to={
                                                        process.env.PUBLIC_URL +
                                                        "/"
                                                      }
                                                      onClick={childItem.click}
                                                      className="nav-link"
                                                      data-bs-toggle="collapse"
                                                    >
                                                      {childItem.icon && (
                                                        <i
                                                          className={
                                                            childItem.icon
                                                          }
                                                        ></i>
                                                      )}{" "}
                                                      {props.t(childItem.label)}
                                                    </Link>
                                                    <Collapse
                                                      className="menu-dropdown"
                                                      in={
                                                        childItem.stateVariables
                                                      }
                                                    >
                                                      <div>
                                                        <ul className="nav nav-sm flex-column">
                                                          {childItem.subItems.map(
                                                            (
                                                              subChildItem: any,
                                                              key: number
                                                            ) => (
                                                              <li
                                                                className="nav-item"
                                                                key={key}
                                                              >
                                                                <Link
                                                                  to={
                                                                    subChildItem.link
                                                                  }
                                                                  className="nav-link"
                                                                  onClick={() => {
                                                                    // Clear all table states when clicking sidebar navigation links
                                                                    if (
                                                                      subChildItem.link &&
                                                                      subChildItem.link !==
                                                                        "/#"
                                                                    ) {
                                                                      clearAllTableStates();
                                                                    }
                                                                  }}
                                                                >
                                                                  {subChildItem.icon && (
                                                                    <i
                                                                      className={
                                                                        subChildItem.icon
                                                                      }
                                                                    ></i>
                                                                  )}{" "}
                                                                  {props.t(
                                                                    subChildItem.label
                                                                  )}
                                                                </Link>
                                                              </li>
                                                            )
                                                          )}
                                                        </ul>
                                                      </div>
                                                    </Collapse>
                                                  </li>
                                                )}
                                              </React.Fragment>
                                            )
                                          )}
                                      </ul>
                                    </div>
                                  </Collapse>
                                </li>
                              )}
                            </React.Fragment>
                          )
                        )}
                    </ul>
                  </div>
                </Collapse>
              </li>
            ) : (
              <li className="nav-item">
                <Link
                  to={item.link ? item.link : "/"}
                  className="nav-link menu-link"
                  data-set={item?.activeUrl}
                  data-menu-id={item.id}
                  onClick={() => {
                    // Clear all table states when clicking sidebar navigation links
                    if (item.link && item.link !== "/#") {
                      clearAllTableStates();
                    }
                  }}
                >
                  <i className={item.icon}></i>{" "}
                  <span>{props.t(item.label)}</span>
                  {item.badgeName ? (
                    <span
                      className={
                        "badge badge-pill badge-soft-" + item.badgeColor
                      }
                      data-key="t-new"
                    >
                      {item.badgeName}
                    </span>
                  ) : null}
                </Link>
              </li>
            )}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

VerticalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(VerticalLayout));
